// AuraBase Mock Data

// Landing-page data — display text lives in i18n locales (locales/*.json -> "landing").
// Here only structural / non-translatable fields are kept.

export const navLinks = [
  { key: 'features', href: '#features' },
  { key: 'pricing', href: '/pricing' },
  { key: 'resources', href: '#resources' },
  { key: 'about', href: '#about' },
];

export const features = [
  { id: 'communities', icon: 'Users', image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80' },
  { id: 'courses', icon: 'GraduationCap', image: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800&q=80' },
  { id: 'events', icon: 'Calendar', image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80' },
];

export const pricingPlans = [
  { id: 'free', price: 0, popular: false },
  { id: 'pro', price: 49, popular: true },
  { id: 'enterprise', price: 199, popular: false },
];

export const testimonials = [
  { id: 1, avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80' },
  { id: 2, avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80' },
  { id: 3, avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80' },
];

export const stats = [
  { key: 'communities', value: '10K+' },
  { key: 'members', value: '2M+' },
  { key: 'courses', value: '50K+' },
  { key: 'uptime', value: '99.9%' },
];

// Dashboard Mock Data
export const mockUser = {
  id: '1',
  name: 'John Doe',
  email: 'john@example.com',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&q=80',
  plan: 'pro',
};

export const mockCommunities = [
  {
    id: '1',
    name: 'Product Designers Hub',
    description: 'A community for product designers to share and learn.',
    members: 1247,
    posts: 324,
    image: 'https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=400&q=80',
    role: 'admin',
  },
  {
    id: '2',
    name: 'Startup Founders',
    description: 'Connect with fellow founders and share experiences.',
    members: 3892,
    posts: 1205,
    image: 'https://images.unsplash.com/photo-1553028826-f4804a6dba3b?w=400&q=80',
    role: 'member',
  },
  {
    id: '3',
    name: 'Creative Writers Circle',
    description: 'Share your stories, get feedback, grow together.',
    members: 856,
    posts: 2341,
    image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?w=400&q=80',
    role: 'moderator',
  },
];

export const mockCourses = [
  {
    id: '1',
    title: 'UX Design Fundamentals',
    description: 'Master the basics of user experience design.',
    instructor: 'Sarah Chen',
    lessons: 24,
    duration: '8 hours',
    students: 1893,
    progress: 65,
    image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400&q=80',
    price: 99,
  },
  {
    id: '2',
    title: 'Building SaaS Products',
    description: 'From idea to launch - complete guide.',
    instructor: 'Marcus Johnson',
    lessons: 36,
    duration: '12 hours',
    students: 2456,
    progress: 30,
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=80',
    price: 149,
  },
  {
    id: '3',
    title: 'Community Building 101',
    description: 'Learn to build and grow engaged communities.',
    instructor: 'Emily Rodriguez',
    lessons: 18,
    duration: '6 hours',
    students: 987,
    progress: 0,
    image: 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=400&q=80',
    price: 79,
  },
];

export const mockEvents = [
  {
    id: '1',
    title: 'Product Design Workshop',
    description: 'Interactive workshop on modern product design techniques.',
    date: '2025-07-25T18:00:00Z',
    duration: '2 hours',
    host: 'Sarah Chen',
    attendees: 156,
    maxAttendees: 200,
    type: 'workshop',
    image: 'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=400&q=80',
    isLive: false,
  },
  {
    id: '2',
    title: 'Founder AMA Session',
    description: 'Ask me anything with successful startup founders.',
    date: '2025-07-22T20:00:00Z',
    duration: '1.5 hours',
    host: 'Marcus Johnson',
    attendees: 89,
    maxAttendees: 100,
    type: 'ama',
    image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=400&q=80',
    isLive: true,
  },
  {
    id: '3',
    title: 'Weekly Community Call',
    description: 'Our regular community catch-up and updates.',
    date: '2025-07-28T17:00:00Z',
    duration: '1 hour',
    host: 'Emily Rodriguez',
    attendees: 234,
    maxAttendees: 500,
    type: 'call',
    image: 'https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=400&q=80',
    isLive: false,
  },
];

export const mockPosts = [
  {
    id: '1',
    author: { name: 'Sarah Chen', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80' },
    content: 'Just launched our new design system! Check it out and let me know your thoughts.',
    likes: 47,
    comments: 12,
    createdAt: '2025-07-20T10:30:00Z',
    community: 'Product Designers Hub',
  },
  {
    id: '2',
    author: { name: 'Marcus Johnson', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80' },
    content: 'Great discussion today about scaling startups. Thanks everyone who joined!',
    likes: 89,
    comments: 23,
    createdAt: '2025-07-19T15:45:00Z',
    community: 'Startup Founders',
  },
];
